import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cdnUrl } from "commons/cdn";
import {
  CheckCircledIcon,
  DownloadIcon,
  HeartFilledIcon,
  StarFilledIcon,
} from "@radix-ui/react-icons";
import { delFetcher } from "api/swr";
import React from "react";
import useSWRMutation from "swr/mutation";
import DisplayUpdateTime from "ui/DisplayUpdateTime";
import { MyImage } from "components/MyImage";

const Stat = ({ tip, className = "", children }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <div className={`flex cursor-help items-center gap-1 ${className}`}>
        {children}
      </div>
    </TooltipTrigger>
    <TooltipContent>{tip}</TooltipContent>
  </Tooltip>
);

const Item = ({ data }) => {
  const { trigger, isMutating } = useSWRMutation(
    "/avatars/webimgs/",
    delFetcher,
  );

  if (!data) {
    return null;
  }

  const onDelete = () => {
    //TODO: add a confirm dialog
    if (isMutating) return;
    trigger(data.id);
  };

  return (
    <div className="flex h-full min-h-0 flex-col gap-1 border p-1">
      <div className="flex flex-1 flex-col gap-1">
        <MyImage
          alt={data.authorName || "web image"}
          src={cdnUrl(data.url)}
          className="aspect-square w-full rounded object-cover transition-all hover:scale-105"
        />
        <p className="text-xs text-muted-foreground">
          <DisplayUpdateTime updateTime={data?.updateTime} />
        </p>
        <p>@{data.authorName || "-"}</p>
        <TooltipProvider delayDuration={200}>
          <div className="grid grid-cols-2 gap-x-2 gap-y-1">
            <Stat tip="点赞数">
              <HeartFilledIcon className="shrink-0 text-destructive" />
              {data.likeCount ?? 0}
            </Stat>
            <Stat tip="收藏数">
              <StarFilledIcon className="shrink-0 text-destructive" />
              {data.starCount ?? 0}
            </Stat>
            <Stat tip="使用数（设为壁纸）">
              <CheckCircledIcon className="shrink-0" />
              {data.useCount ?? 0}
            </Stat>
            <Stat tip="今日下载 / 总下载" className="whitespace-nowrap">
              <DownloadIcon className="shrink-0" />
              {data?.dailyCount?.downloadCount ?? 0}/{data?.dCount ?? 0}
            </Stat>
          </div>
        </TooltipProvider>
      </div>
      <div className="mt-auto w-full">
        <Button
          variant="outline"
          onClick={onDelete}
          className="w-full hover:bg-destructive hover:text-white"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default Item;
